<template>
  <div>
    <b-modal v-model="$parent.modalQuestion" hide-footer centered size="sm">
      <template v-slot:modal-title>
        <p class="h5">Plan related questions</p>
      </template>
      <div class="d-block text-center">
        <div
          v-for="(item, idx) in planAnswers"
          :key="idx"
          class="container mt-2"
        >
          <choice
            v-if="item.type_question == '1' || item.type_question == '2'"
            :responses="item.answers"
            :question="item.question"
            :index="idx + 1"
            :id="item.id"
            class="mb-3"
            :onModal="true"
          />

          <range
            v-if="item.type_question == '3'"
            :responses="item.answers"
            :question="item.question"
            :index="idx + 1"
            :id="item.id"
            class="mb-3"
            :onModal="true"
          />

          <open-answer
            v-if="item.type_question == '4'"
            :responses="item.answers"
            :question="item.question"
            :index="idx + 1"
            :id="item.id"
            class="mb-3"
            :onModal="true"
          />

          <fill-table
            v-if="item.type_question == '5'"
            :responses="item.answers"
            :question="item.question"
            :index="idx + 1"
            :id="item.id"
            class="mb-3"
            :onModal="true"
          />

          <fill-time
            v-if="item.type_question == '6'"
            :responses="item.answers"
            :question="item.question"
            :index="idx + 1"
            :id="item.id"
            class="mb-3"
            :onModal="true"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import choice from "@/components/planning/answers/choice.vue";
import range from "@/components/planning/answers/range.vue";
import openAnswer from "@/components/planning/answers/openAnswer.vue";
import fillTable from "@/components/planning/answers/fillTable.vue";
import fillTime from "@/components/planning/answers/fillTime.vue";

export default {
  props: {
    Gid: Number,
    planAnswers: Array
  },
  components: {
    choice,
    range,
    openAnswer,
    fillTable,
    fillTime
  }
};
</script>
